import { useContext, useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import { ReportTable } from '../components/reportTable';
import { getDataSource } from '../api/ds';
import { FindTextField } from '../components/FindTextField';
import { Tabs, Tab, styled, Typography, Button, Dialog, TextField, Divider, Tooltip } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemText } from '@mui/material';
import { colors } from '../styles/colors';
import Paper from '@mui/material/Paper';
import { styleTable } from '../components/reportTable';
import { TabPanel } from '../components/tabPanel';
import useOn from 'components/socketLib/UseOn';
import { useDataContextDeal } from 'actions/contextDealClient';
import { useNavigate, unstable_usePrompt as usePrompt } from 'react-router-dom';
import { AddProducts } from 'components/AddProducts';
import { DateMenu } from 'components/RangeDate';
import { get, post } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import usePreventDoubleClick from 'components/AntiDBC';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { MarketClientSelector } from 'store/slices/marketClient';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useLocalNotifications } from 'components/Events';
import { SelectProductTocopy } from 'components/EIComponents/ProductInfo';
import { ShowModal } from "components/Modal";
import { getTMPVersion } from 'components/TechSpecif';
import { useBlocker } from 'react-router-dom';
import Loading from 'components/Load';
import Scrollbars from 'rc-scrollbars';
import { getNextItem } from 'utils/formatters';
import { NumInputDesign, TextInputDesign } from 'components/EIComponents/LittleComponents';
import { sortProducts } from 'utils/globalSorts';
import TocIcon from '@mui/icons-material/Toc';
import CheckList from 'components/TaskList';
import { hoverStyle } from "styles/main";
import _ from 'lodash';

// поставки по клиентам 
function TableDelivery({ user }) {
    const [isLoading, setLoading] = useState(true);
    // Состояние, указывающее, есть ли несохраненные изменения в форме
    const [isFormDirty, setIsFormDirty] = useState(false);
    // Флаг для перехода на другую страницу после успешной операции
    const [shouldNavigate, setShouldNavigate] = useState(false);
    // Данные
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([]);
    /** @type {[any, Function]} */
    const [MW, setMW] = useState(undefined);
     // Количество тюков
    const [countBale, setCountBale] = useState(1);
    // склад фулы и склад маркета
    const [warehouse_tranzit, setwarehouse_tranzit] = useState("");
    const [warehouse_market, setWarehouse_market] = useState("");
    const [pickup_addr, setPickup_addr] = useState("");
    const [pickup_contact, setPickup_contact] = useState("");
    const [pickup_sign, setPickup_sign] = useState("");
    const [pickup_volume, setPickup_volume] = useState("");
    const [pickup_date, setPickup_date] = useState(new Date());
    // дата отгрузки
    const [date_shipment, setDate_shipment] = useState(new Date());
    // состояние ошибки, если пользователь напортачил
    const [error, setError] = useState(false);
    // Состояние для открытия модального окна добавления товара
    const [open, setOpen] = useState(false);
    // Навигационный хук из React
    const navigate = useNavigate();
    // получаем дескриптор
    const ds = useMemo(() => getDataSource('dealClient'), []);
    // получаем контекст с выбранными товарами
    /** @type {any} */
    const { dataContext, clearContextData } = useDataContextDeal();
    const { socket } = useContext(SocketContext);
    const { company_id, user_id  } = useSelector(
        loginSelector
      );
    const { market } = useSelector(MarketClientSelector);
    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();
    const [openCopy, setOpenCopy] = useState(false);
    /** @type {[any, Function]} */
    const [copyData, setCopyData] = useState(undefined)
    // const [isDelivery, setDelivery] = useState(false);

    /** @type {[any, Function]} */
    const [showList, setShowList] = useState(undefined)
    

    const blocker = useBlocker(
        ({ nextLocation, currentLocation }) =>
            isFormDirty && nextLocation.pathname !== currentLocation.pathname
    );

    // обновляем кол-во страниц, когда залились пдф файлы
    useOn('updateCountPages', ($data) => {
        console.log('DATA DELIVERY', $data)
        if ($data) {
            const index = data.findIndex((el) => el.size.barcode === $data.size);
            const index1 = data.findIndex((el) => el.size.barcode === $data.size)
            console.log('INDEX DELIVERY', index)
            if (index !== -1) {
                data[index].size.countQr = $data.count;
                data[index1].qrcode.count = $data.count;
                setData(JSON.parse(JSON.stringify(data)));
            }
        }
    });
     // Хук для предупреждения пользователя при попытке уйти со страницы с несохраненными изменениями
    useEffect(() => {
        if (blocker.state === "blocked") {
            ShowModal(
                'Несохраненные изменения',
                <div>У вас есть несохраненные изменения. Вы уверены, что хотите покинуть страницу?</div>,
                async () => {
                    blocker.proceed(); 
                }
            );
        }
    }, [blocker]);

    // при необходимости перехода на другую страницу, если форма не заполнялась или сохранена
    useEffect(() => {
        if (shouldNavigate && !isFormDirty) {
            navigate('..', { relative: 'path', replace: true });
        }
    }, [shouldNavigate, isFormDirty, navigate]);

    // Функция создания новой поставки
    const create = async () => {
        setLoading(true)
        let tmpData = JSON.parse(JSON.stringify(data))
        try {
            if (tmpData.length === 0) {
                showNotification({
                    id: 'Null Products', 
                    type: 'error', 
                    message: 'Ни один товар не добавлен' 
                });
                return
            }

            // let AvConsumes = undefined
            // if (!isDelivery) {
                // AvConsumes = await get('Deal/getAvConsumesCounts', {cid:user_id})
            // }
            let AvConsumes = await get('Deal/getAvConsumesCounts', {cid:user_id})

            const $data = [];
            let err = false
            // let noComplectInTz = false
            let needComplectCount = 0
            let noComplectCount = false
            let units = 0
            for (const el of tmpData) {
                // Собираем объект товара
                const item = { nmID: el.nmID, countProduct: el.countProduct, ...el.data, size: el.size };
                console.log("el.size", el.size)
                delete item.size.countQr
                let tz = {
                    text:item.size.techTask?.versions?.[item.size.techTask.TZV]?.text || undefined,
                    services:item.size.techTask?.versions?.[item.size.techTask.TZV]?.services || undefined,
                    print:item.size.techTask?.versions?.[item.size.techTask.TZV]?.print || undefined,
                    version: item.size.techTask.TZV
                }
                if (!tz.services && !tz.text) {
                    err = true
                    break
                }


                //Прописываем свойство noCalc для расходников
                for (let tl of item.size.techTask.versions[item.size.techTask.TZV].tasklist) {
                    console.log("tl", tl)
                    if (tl.checked) {
                        let servParts = tl.serv.split(':')
                        if (servParts.length === 2) {
                            let idx = tz.services.findIndex((fel) => fel.name === servParts[0])
                            console.log("idx", idx)
                            if (idx > -1) {
                                for (let sel of Object.keys(tz.services[idx].data)) {
                                    let subidx = tz.services[idx].data[sel].findIndex((fel) => fel.name === servParts[1])
                                    console.log("subidx", subidx)
                                    tz.services[idx].data[sel][subidx].noCalc = true
                                }
                                
                            }
                        }
                        
                    }
                }
            

                //Прикрепляем таск лист
                item.task_list = item.size.techTask.versions[item.size.techTask.TZV].tasklist

                // if (!isDelivery) {
                    let servIdx = tz.services.findIndex((fel) => fel.name === 'Комплектация товара')
                    if (servIdx > -1) {
                        // noComplectInTz = true
                        // break
                        needComplectCount +=1
                        //////////проверяем, хватает ли расходников
                        // let tmpErr = false
                        // tz.services[servIdx].data.consumes.map((cons) => {
                        // if (!AvConsumes[`cons${cons.id}`] || AvConsumes[`cons${cons.id}`] < el.countProduct * cons.count) {
                        //     tmpErr = true
                        // }
                        // })
                        // //Если хватает, чтобы добить товар, то вычитаем из расходников
                        // if (!tmpErr) {
                        //     tz.services[servIdx].data.consumes.map((cons) => {AvConsumes[`cons${cons.id}`] -= el.countProductt * cons.count})
                        // }
                        // else {
                        //     noComplectCount = true
                        //     break
                        // }
                    }

                // }
                delete item.size.techTask
                item.size.techTask = tz
                units += parseInt(item.countProduct);
                $data.push(item);
            }

            if (err) {
                showNotification({
                    id: 'NOTZ', 
                    type: 'error', 
                    message: 'У некоторых товаров не указано техническое задание' 
                });
                return 
            }
            // if (noComplectInTz) {
            //     showNotification({
            //         id: 'NOTZComplect', 
            //         type: 'error', 
            //         message: 'У некоторых товаров не указаны расходники для комплектации' 
            //     });
            //     return 
            // }
            if (noComplectCount) {
                showNotification({
                    id: 'NOTZComplectCount', 
                    type: 'error', 
                    message: 'Расходников недостаточно для сборки заявленного количества товаров' 
                });
                return 
            }

            console.log("needComplectCount", needComplectCount, "/", $data.length)
            const cli = await get('Clients/get', {cid:user_id});
            let sku = $data.length;
            let nd = await post('Deal/create', 
                {
                    products: $data, 
                    count_bale: countBale, 
                    warehouse_tranzit: warehouse_tranzit, 
                    warehouse_market: warehouse_market, 
                    date_shipment, 
                    id_company: company_id, 
                    id_client: user_id, 
                    id_manager: Number(cli.message.manager_id), 
                    market: market, 
                    number_order: "", 
                    status: 1, 
                    type: needComplectCount !== $data.length? "pik_goods": "moving_deals",//Важно, так он попадает в раздел Отгрузка/Движение
                    data:{
                            sku,
                            units,
                            end_date:date_shipment,
                            pickup: {
                                contact:pickup_contact,
                                addr:pickup_addr,
                                sign:pickup_sign,
                                volume:pickup_volume,
                                date: pickup_date
                            },
                            ...(MW && { MW }) // Добавляем MW только если оно не undefined
                        },
                })
            if (nd?.id) {
                //Лог о содании сделки
                await post("Logs/create", {
                    deal_id:nd.id,
                    user_type:"cli",
                    user_id,
                    type: "create_deal",
                    data: {
                        sku,
                        units,
                    }
                })
                socket.emit('add_new_deal', {company_id, type: needComplectCount !== $data.length? "pik_goods": "moving_deals", id:nd.id});
                setShouldNavigate(true);
                setIsFormDirty(false);
            }
            else {
                showNotification({
                    id: 'createDealErr', 
                    type: 'error', 
                    message: 'Ошибка при создании сделки, сообщите администратору' 
                });
            }
        }   
        catch (e) {
            console.log(e)
        }
        finally {
            setLoading(false)
        }
    }


    const changeRow = async ($data) => {
        console.log("$data", $data)
        if ($data.fk && $data.fk==='count') {
            let tmp = JSON.parse(JSON.stringify(data))
            const found = tmp.findIndex((el) => String(el.id) === String($data.row.id))
            if (found !== -1) {
                tmp[found].countProduct = $data.count
            }
            setData(tmp)
            return
        }
        changeTechText($data)
    }
    
    // Обработка изменений технического задания
    const changeTechText = async ($data, noNotif = false) => {
        console.log("$data", $data)
        if ($data.swap) {
            const found = data.findIndex((el) => String(el.id) === String($data.row.id))
            if (found !== -1) {
                data[found].size.techTask.TZV = $data.swap
            }
            return
        }
        if (!$data.copy) {
            const found = data.findIndex((el) => String(el.id) === String($data.row.id))
            if (found !== -1) {

                //запоминаем матаданные
                const barcode = data[found].size.techTask?.barcode;
                const title = data[found].size.techTask?.title
                const vendorCode = data[found].size.techTask?.vendorCode
                
                //Проверяем, существовала ли ранее такая версия
                const isCreating = !data[found].size.techTask || (
                    !data[found].size.techTask.versions[$data.version]?.text &&
                    !data[found].size.techTask.versions[$data.version]?.services &&
                    !data[found].size.techTask.versions[$data.version]?.print
                )
                // Выполняем запрос на создание
                if (isCreating) {
                    await post('techTask/create', {
                        barcode: barcode,
                        client_id: user_id,
                        market,
                        text: $data.text,
                        services: $data.services,
                        print: $data.print,
                        version: $data.version,
                        comment: $data.comment,
                        fbs: $data.fbs,
                        hide: $data.hide
                    });
                    if (!noNotif) {
                        showNotification({
                        id: 'fieldsErr', 
                        type: 'success', 
                        message: 'ТЗ успешно создано' 
                        });
                    }
                } 
                else {
                    //Проверяем, нет ли уже существующих сделок с этим тз
                    let useInDeals = await get('Deal/checkTZ', {
                        tz: $data.version, 
                        nmID: data[found].nmID,
                        barcode: data[found].size.barcode,
                        market
                        }
                    )

                    //Обнуляем taskList, если изменены услуги
                    if ($data.services !== data[found].techTask.versions[$data.version]?.services) {
                        delete data[found].techTask.versions[$data.version].tasklist
                    }

                    //Если сделки с таким тз уже существуют и измененоо хотя бы одно из ключевых полей
                    //Создаем новую версию
                    if (
                        useInDeals.message &&
                        ( 
                            $data.text !== data[found].techTask.versions[$data.version]?.text ||
                            // $data.services !== data[found].techTask.versions[$data.version]?.services ||
                            !_.isEqual($data.services, data[found].techTask.versions[$data.version]?.services) ||
                            $data.print !== data[found].techTask.versions[$data.version]?.print
                        )
                    ) {
                        $data.version = `alt_${Object.keys(data[found].techTask.versions).length+1}`
                        await post('techTask/create', {
                            barcode: barcode,
                            client_id: user_id,
                            market,
                            text: $data.text,
                            services: $data.services,
                            print: $data.print,
                            version: $data.version,
                            comment: $data.comment,
                            fbs: $data.fbs,
                            hide: $data.hide
                        });
                        showNotification({
                            id: 'fieldsErr', 
                            type: 'success', 
                            message: 'Альтернативаная версия ТЗ успешно создана' 
                        });
                    }
                    //Если же нет сделак с таком tz или не изменено ни одно из ключевых полей, то можем просто обновить его
                    else {
                        await post('techTask/update', {
                            barcode: barcode,
                            client_id: user_id,
                            market,
                            text: $data.text,
                            services: $data.services,
                            print: $data.print,
                            version: $data.version,
                            comment: $data.comment,
                            fbs: $data.fbs,
                            hide: $data.hide
                        });
                        showNotification({
                            id: 'fieldsErr', 
                            type: 'success', 
                            message: 'ТЗ успешно обновлено' 
                        });
                    }
                }
                
                let updatedData = await get("techTask/getOnProduct", {bar: barcode, cid: user_id, market: market})

                //Сохраняем такс листы
                let tmpTLs = {}
                for (let v of Object.keys(data[found].size.techTask.versions)) {
                    if (tmpTLs[v]?.tasklist) {
                        tmpTLs[v] = data[found].size.techTask.versions[v].tasklist
                    }
                }

                //Скрываем тз
                let tmpVersions = {}
                if (updatedData.versions) {
                    for (let vel of Object.keys(updatedData.versions)) {
                        if (!updatedData.versions[vel].hide || updatedData.versions[vel].verison === $data.version) {
                            tmpVersions[vel] = updatedData.versions[vel]
                        }
                    }
                }

                data[found].size.techTask = {
                    barcode: barcode,
                    title: title,
                    vendorCode:vendorCode,
                    versions: tmpVersions,
                    TZV: $data.version
                };

                //восстанавливаем такс листы
                for (let tl of Object.keys(tmpTLs)) {
                    if (data[found].size.techTask.versions[tl]) {
                        data[found].size.techTask.versions[tl].tasklist = tmpTLs[tl]
                    }
                }

                await createTaskLists(JSON.parse(JSON.stringify(data)))

                // setData(JSON.parse(JSON.stringify(data)));
            }
        }
        else {
            setCopyData(JSON.parse(JSON.stringify($data)))
            setOpenCopy(true)
        }
    }

    const copyTechTask = async (list) => {
        console.log(list)
        delete copyData.copy
        console.log("copyData", copyData)
        for (let el of list) {
            let versList = Object.keys(data.find((fel) => String(fel.id) === el).size.techTask.versions)
            await changeTechText({...copyData, version: getNextItem(versList), row: {id: el}}, true)
        }
        setCopyData(undefined)
        showNotification({
          id: 'succesCopy', 
          type: 'success', 
          message: 'ТЗ успешно скопировано' 
        });
    }

    const [allSKU, setAllSKU] = useState(0)
    const [allProduct, setAllProduct] = useState(0)

    const counttest = () =>{
        console.log("test", data)
        let allsku = 0
        let allproduct = 0
        if (data && data.length > 0){
            allsku = data.length
            for(let i = 0 ; i < data.length ; i++){
                allproduct += data[i].countProduct;
            }

        }
        
        setAllSKU(allsku)
        setAllProduct(allproduct)
    }

    useEffect(() => {
        counttest()
    }, [data]); 

    const createTaskLists = async ($data)  => {
        await Promise.all($data.map(async (el) => {
            await Promise.all(Object.keys(el.size.techTask.versions).map(async (v) => {
                if (!el.size.techTask.versions[v].tasklist) {
                    el.size.techTask.versions[v].tasklist = await post("Deal/getClearTaskList", {services: el.size.techTask.versions[v].services})
                }
            }))
        }))

        setData($data);
        counttest()
        clearContextData();
        setLoading(false)
    }

    // Обработка полученного из контекста
    useEffect(() => {
        if (dataContext) {
            setLoading(true)
            setIsFormDirty(true);
            console.log("dataContext", dataContext)
            // setDelivery(dataContext.isDelivery)
            // предобработка данных под формат, чтобы отображать в таблице и редактировать
            let tmp = JSON.parse(JSON.stringify(data))
            for (const el of dataContext.deal) {
                let idx = tmp.findIndex((fel) => fel.nmID === el.nmID && fel.size.barcode === el.size.barcode)
                if (idx === -1) {
                    el.qrcode = { id: el.id, nmID: el.nmID, title: el.data.title, size: el.size, market: el.market, company: company_id, count: el.size.countQr, vendorCode: el.data.vendorCode};                  
                    if (el.size.techTask) {
                        el.size.techTask.barcode = el.size.barcode; 
                        el.size.techTask.title = el.data.title; 
                        el.size.techTask.vendorCode = el.data.vendorCode
                        el.size.techTask.TZV = 'main'
                        
                        //Скрытые версии
                        let tmpVersions = {}
                        if (el.size.techTask.versions) {
                            for (let vel of Object.keys(el.size.techTask.versions)) {
                                if (!el.size.techTask.versions[vel].hide || el.size.techTask.versions[vel].verison === el.size.techTask.TZV) {
                                    tmpVersions[vel] = el.size.techTask.versions[vel]
                                }
                            }
                        }
                        el.size.techTask.versions = tmpVersions

                    }
                    else {
                        el.size.techTask =  {
                            barcode: el.size.barcode, 
                            title: el.data.title, 
                            vendorCode: el.data.vendorCode,
                            TZV: 'main'
                        }
                    }
                    tmp.push(el)
                }               
                else {
                    tmp[idx].countProduct += el.countProduct
                } 
            }
            if (dataContext.multiWay) {
                setMW(dataContext.multiWay)
            }

            createTaskLists(tmp)

        } else {
            // Если данных нет — возвращаемся на предыдущую страницу
            if (data.length === 0) {
                navigate('..', { relative: 'path', replace: true });
            }
        }
    }, [dataContext]);

    const del = async (id) => {
        let tmp = JSON.parse(JSON.stringify(data))
        let idx = tmp.findIndex((fel) => fel.id === id)
        if (idx > -1) {tmp.splice(idx, 1)}
        setData(tmp)
    }
    const handleClickDelProduct = (item) => {
        ShowModal('Удалить товар', 
        <div>Вы уверены, что хотите удалить товар?</div>, 
        async () => {
            try {
            del(item)
            }
            catch (err) {}
            finally {}
            
        });
    }

    const changeTaskList = async (id, list) => {
        
        setLoading(true)
        
        let tmp = JSON.parse(JSON.stringify(data))
        let idx = tmp.findIndex((fel) => fel.id === id)
        
        if (idx > -1) {
            tmp[idx].size.techTask.versions[tmp[idx].size.techTask.TZV].tasklist = list

            showNotification({
                id: 'task_list_ok', 
                type: 'success', 
                message: 'Состояние листа задач обновлено' 
            });

        }

        setData(tmp)

        setShowList(undefined)

        setLoading(false)

    }

    const showTaskList = (item) => {
        console.log('item', item)
    
        setShowList({id: item.id, task_list: item.size.techTask.versions[item.size.techTask.TZV].tasklist})
    }

    console.log("data", data)

    return (
        <Box height="100%" width={"100%"} display="flex" flexDirection="column" >
            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '620px', width: '1200px', padding: '12px' }}>
                    {/* <AddProducts navigateDeal={false} cancel={setOpen} isDelivery={isDelivery}></AddProducts> */}
                    <AddProducts navigateDeal={false} cancel={setOpen} ></AddProducts>
                </div>
            </Dialog>
            <Dialog
                open={openCopy}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpenCopy(false) }}
            >
                <div style={{ height: '620px', width: '1000px', padding: '12px', }}>
                    <SelectProductTocopy data={data.filter((el) => el.id !== copyData?.row?.id)} cancel={setOpenCopy} onCopy={(list) => {copyTechTask(list)}}></SelectProductTocopy>
                </div>
            </Dialog>
            <Dialog
                open={showList !== undefined}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setShowList(undefined) }}
            >
                <div style={{ height: '700px', width: '500px', padding: '12px' }}>
                    <CheckList list={showList?.task_list || []} onChange={(nl) => {if (showList?.id) {changeTaskList(showList.id, nl)}}} onCancel={() => {setShowList(undefined)}}></CheckList>
                </div>
            </Dialog>
            <Box 
                sx={{
                    width: "98%",
                    height: '20%',
                    margin: "1% 1% 0% 1%",
                    display:'flex', 
                    flexDirection:'row', 
                    gap:2, 
                    padding: "1% 1% 0% 1%",
                    backgroundColor:'white',
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px"
                }}>
                {/* {isDelivery &&  */}
                    <div style={{display: "flex", flexDirection:"column", gap: "2px", width: "30%"}}>
                        <TextInputDesign title={"Адрес для забора:"} val={pickup_addr} onChange={(v) => setPickup_addr(v)}/>
                        <TextInputDesign title={"Контакт:"} val={pickup_contact} onChange={(v) => setPickup_contact(v)}/>
                        <TextInputDesign title={"Подписание груза:"} val={pickup_sign} onChange={(v) => setPickup_sign(v)}/>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <NumInputDesign title={"Кол-во мест"} val={countBale} onChange={(v) => setCountBale(v)}/>
                            <NumInputDesign title={"Объём в м³"} val={pickup_volume} onChange={(v) => setPickup_volume(v)}/>
                        </div>
                        <div style={{display:'flex', flexDirection:'row', alignContent:'center', alignItems:'center', marginTop:"2px"}}>
                            <span style={{marginRight: "5px"}}>Дата забора: </span>
                            <DateMenu date={pickup_date} onChange={setPickup_date}/>
                        </div>
                    </div>
                {/* } */}
                {/* {isDelivery &&  */}
                    <div style={{ display:"flex", alignItems:"center"}}>
                        <Divider orientation="vertical" sx={{ borderRightWidth: "3px", height:"95%" }} />
                    </div>
                {/* } */}
                <div style={{display: "flex", flexDirection:"column", gap: "2px", width: "30%"}}>
                    <TextInputDesign title={"Транзитный склад:"} val={warehouse_tranzit} onChange={(v) => setwarehouse_tranzit(v)}/>
                    <TextInputDesign title={"Склад назначения:"} val={warehouse_market} onChange={(v) => setWarehouse_market(v)}/>
                    <div style={{display:'flex', flexDirection:'row', alignContent:'center', alignItems:'center', marginTop:"2px"}}>
                        <span style={{marginRight: "5px"}}>Дата отгрузки: </span>
                        <DateMenu date={date_shipment} onChange={setDate_shipment}/>
                    </div>
                </div>
                <div style={{ display:"flex", alignItems:"center"}}>
                    <Divider orientation="vertical" sx={{ borderRightWidth: "3px", height:"95%" }} />
                </div>
                <div style={{display: "flex", flexDirection:"column", gap: "2px", width: "30%"}}>
                    <span>Количество товара: {allProduct}</span>
                    <span>SKU: {allSKU}</span>
                </div>
            </Box>
            <div style={{
                width: '98%', 
                height: '72%',
                margin: "0% 1% 1% 1%",
                backgroundColor:'white',
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px"
            }}>
                {isLoading? <Loading></Loading>
                :
                <Scrollbars
                    style={{ width: '100%', height: '100%', borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}
                >
                    <ReportTable 
                        ds={ds} 
                        data={sortProducts(data)} 
                        onFormatterChange={changeRow}
                        aditionalAction={
                            [
                                {
                                    action: (item) => {handleClickDelProduct(item.id)},
                                    ui: () => {return (
                                        <DeleteForeverIcon
                                            sx={{
                                                transition: 'all 0.3s ease',
                                                '&:hover': hoverStyle
                                            }}
                                        />
                                    )}
                                },
                                {
                                    action: (item) => {showTaskList(item)},
                                    ui: () => {return (
                                        <Tooltip title={"Указать уже готовую обработку"}>
                                            <TocIcon
                                                sx={{
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': hoverStyle
                                                }}
                                            />
                                        </Tooltip>
                                    )}
                                },
                            ]
                        }
                    />
                </Scrollbars>
                }
            </div>
            <Box height="5%" display="flex" justifyContent="right" alignItems="center" px={2} sx={{marginBottom: "1%"}}>
                <Button variant="contained" onClick={() => { setOpen(true) }}
                    disabled={isLoading}
                    sx={{ textTransform: 'none', marginRight: '10px', backgroundColor: colors.elements, fontWeight: 'bold' }} >
                    Добавить товар
                </Button>
                <Button variant="contained"
                    onClick={preventDoubleClick(create, 1000)}
                    disabled={isLoading}
                    sx={{ textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }} >
                    Создать поставку
                </Button>
            </Box>
        </Box>

    );
}

export function DeliveryClient() {
    const [tab, setTab] = useState(0);
    const handleChange = (event, newTab) => {
        setTab(newTab);
    };

    const { user_id, company_id} = useSelector(
        loginSelector
    );

    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState({
        id: user_id,
        company_id: company_id,
        api_key: "",
        data: "",
        deleted: undefined,
        email: "",  
        fio: "testmng",
        ip_id: "",
        manager_id: "1",
        mobile_number: "",
        status: ""
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
            const responseData = await get('Clients/get', {cid:user_id});
            if (responseData?.message) {
                let obj = {
                    id: user_id,
                    company_id: company_id,
                    api_key: responseData.message.api_key || undefined,
                    data: responseData.message.data || undefined,
                    deleted: responseData.message.deleted || undefined,
                    email: responseData.message.email || "Не указано",  
                    fio: responseData.message.fio || "Не указано",
                    ip_id: responseData.message.ip_id || undefined,
                    manager_id: responseData.message.manager_id || undefined,
                    mobile_number: responseData.message.mobile_number || "Не указано",
                    status: responseData.message.status || "Не указано",
                }
                setUser(obj)
            }
            } catch (err) {
            } finally {
            setLoading(false);
            }
        };

        fetchData();
    }, []);

    
    return (
        <TableDelivery user={user}/>
    );
}